module.exports = __webpack_public_path__ + "static/img/Coockie.e148a2f7.svg";